import { OWebApp } from "oweb";

export default (app: OWebApp) => {

	return {
		launch() {
			if (app.isMobileApp()) {
				document.addEventListener("deviceready", this.deviceReady.bind(this), false);
			} else {
				this.deviceReady();
			}
		},
		deviceReady() {
			setTimeout(app.start.bind(app), 500);
		}
	}
};
